/* eslint-disable no-unused-vars, no-useless-constructor */
import React from "react";
import "./Privacy.css";
import { Helmet } from "react-helmet";

class Privacy extends React.Component {
  constructor(props) {
    super(props);
  }

  checkInterval;
  menuUpdated = false;

  componentDidMount() {
    this.checkInterval = setInterval(() => {
      const oneTrustElement = document.getElementById(
        "otnotice-992457b6-7514-439d-8f42-847cdbdd8326"
      );
      oneTrustElement.style.display = "inline";
      if (!this.menuUpdated) this.updateOneTrustMenuLinks();
    }, 1000);
  }

  updateOneTrustMenuLinks() {
    const menuElements = document.querySelectorAll(
      "ul.otnotice-menu li.otnotice-menu-section a"
    );

    for (let el of menuElements) {
      const targetId = el.getAttribute("href");
      el.removeAttribute("href");
      const target = document.querySelector(targetId);
      el.addEventListener("click", () =>
        target.scrollIntoView({ behavior: "smooth" })
      );
    }

    this.menuUpdated = true;
  }

  componentWillUnmount() {
    clearInterval(this.checkInterval);
    const oneTrustElement = document.getElementById(
      "otnotice-992457b6-7514-439d-8f42-847cdbdd8326"
    );
    oneTrustElement.style.display = "none";
  }

  render() {
    return (
      <>
        <div className="privacy-policies__header">
          <div className="container">
            <a className="privacy-policies__link" href="/">
              <img
                alt="Logo"
                aria-hidden="true"
                width="42"
                height="42"
                src="images/walmart-logo.png"
              />
              <span className="ml-2">Home</span>
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default Privacy;
